export const RenterAIDisclaimerMessage = (properties, renterAIProperties) => {
  const disclaimerProperties = [];

  properties.forEach(property => {
    if (renterAIProperties.includes(property.id)) {
      disclaimerProperties.push(property.name);
    }
  });

  return disclaimerProperties.length ?
  `The following properties are participating in the new
  full GenAI beta and no longer need to manage responses: ${
    disclaimerProperties.join(', ')}` : '';
};
